import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  actionButtonFn: () => void;
  open: boolean;
  onOpenChange: Dispatch<SetStateAction<boolean>>;
  bodyText: string
  title?: string
  actionButtonText?: string
};

const AlertDialogComponent = (props: Props) => {
  const { t } = useTranslation(["common"]);
  const {
    actionButtonFn,
    open,
    onOpenChange,
    bodyText,
    title = "Are you absolutely sure?",
    actionButtonText = t("buttons.confirm")
  } = props;


  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>
            {bodyText}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("buttons.cancel")}</AlertDialogCancel>
          <AlertDialogAction onClick={actionButtonFn}>{actionButtonText}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default AlertDialogComponent;
